import Image from "next/image";
import img2 from "../../public/images/5.webp";

export default function BecomeStudent() {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:ml-24">
          {/* Upper Image - Hidden above 768px */}
          <div className="flex-1 block lg:hidden">
            <Image
              src={img2}
              alt="Get a Counsellor"
              className=""
              width={600}
              height={500}
            />
          </div>

          {/* Text Section */}
          <div className="flex-1 text-left   ">
            <h3 className="text-2xl font-semibold text-gray-800">
              Get a Counsellor
            </h3>
            <p className="mt-4 text-gray-600 leading-relaxed">
              Connect with an Expert—Personalized Guidance for Your NEET Journey
              Awaits!
            </p>
            <div className="mt-6">
              <a
                href="/services"
                className="inline-block px-6 py-2 border border-orange-500 text-orange-500 rounded-full font-medium hover:bg-orange-500 hover:text-white transition"
              >
                Apply Now
              </a>
            </div>
          </div>

          {/* Lower Image - Hidden below 768px */}
          <div className="flex-1 hidden lg:block">
            <Image
              src={img2}
              alt="Get a Counsellor"
              className=""
              width={600}
              height={500}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
